// extracted by mini-css-extract-plugin
module.exports = {"downloadApp":"downloadBar_downloadApp__hphAK","txt":"downloadBar_txt__KPLXa","title":"downloadBar_title__PLj_8","text":"downloadBar_text__fUTjb"};